import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./assets/web/assets/mobirise-icons2/mobirise2.css";
import "./assets/bootstrap/css/bootstrap.min.css";
import "./assets/bootstrap/css/bootstrap-grid.min.css";
import "./assets/bootstrap/css/bootstrap-reboot.min.css";
import "./assets/parallax/jarallax.css";
import "./assets/animatecss/animate.css";
import "./assets/dropdown/css/style.css";
import "./assets/socicon/css/styles.css";
import "./assets/theme/css/style.css";
import "./assets/mobirise/css/mbr-additional.css";
import "./assets/web/assets/uicons-regular-rounded-2.6.0/uicons-regular-rounded/webfonts/uicons-regular-rounded.css";

import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./components/hooks/LanguageContext";
import Products from "./pages/Products";
import Login from "./pages/auth/Login";
import User from "./pages/user/User";
import Success from "./pages/common/Success";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ProductInformation from "./pages/product/ProductInformation";
import ComingSoon from "./pages/common/ComingSoon";
import Exception from "./pages/common/Exception";
import Home from "./pages/home/Home";
import GeoMap from "./pages/geo/GeoMap";
import HomeIT from "./pages/temporary/HomeIT";
import NotFound from "./pages/common/NotFound";
import YandexMetrikaTracker from "./yandex/YandexMetrikaTracker";

export default function App() {
    const wrap = (content) => {
        return (
            <>
                <NavBar />
                {content}
                <Footer />
            </>
        );
    };

    return (
        <AuthProvider>
            <LanguageProvider>
                <Router>
                    <YandexMetrikaTracker />
                    <Routes>
                        <Route path={Home.link} element={wrap(<Home />)} />
                        <Route path={Products.link} element={wrap(<Products />)} />
                        <Route path={Login.link} element={wrap(<Login />)} />
                        <Route path={User.link} element={wrap(<User />)} />
                        <Route path={Success.link} element={wrap(<Success />)} />
                        <Route path={Exception.link} element={wrap(<Exception />)} />
                        <Route path={ComingSoon.link} element={wrap(<ComingSoon />)} />
                        <Route path="/product/:id" element={wrap(<ProductInformation />)} />
                        <Route path={HomeIT.link} element={wrap(<HomeIT />)} />
                        <Route path={GeoMap.link} element={<><NavBar /><GeoMap /></>} />
                        <Route path="*" element={wrap(<NotFound />)} />
                    </Routes>
                </Router>
            </LanguageProvider>
        </AuthProvider>
    );
}